// src/components/Common-components/NavigatorBar/NavigatorContents/navFacilityContent.js
import React, { useState, useEffect, useRef } from 'react';
import styles from '../../../../css/NavigatorBar/NavigatorContents/navFacilityContent.module.css';
import { ReactComponent as ArrowUnder } from '../../../../assets/icons/svg/arrowUnder.svg';
import dummyImage from '../../../../assets/img/detail-dummy/dummy-facilities_7.png'

// 시설 카드 하나를 접고 펼치는 설명 영역과 함께 렌더링한다.
function FacilityCard({ facility_name_ko ,facility_name, image_url = dummyImage, description, description_ko }) {
  const [expanded, setExpanded] = useState(false);
  const [needClamp, setNeedClamp] = useState(false);
  const descRef = useRef(null);
  const handleImageError = (event) => {
    if (event?.currentTarget) {
      event.currentTarget.style.display = 'none';
    }
  };

  useEffect(() => {
    if (descRef.current) {
      const cs = getComputedStyle(descRef.current);
      const lineHeight = parseFloat(cs.lineHeight);
      const height = descRef.current.scrollHeight;
      const lines = Math.round(height / lineHeight);
      setNeedClamp(lines > 5);
    }
  }, []);

  return (
    <div className={styles['facility-card']}>
      <img
        src={image_url || dummyImage}
        alt={`${facility_name_ko || facility_name}_img`}
        className={styles.image}
        onError={handleImageError}
      />
      <h2 className={styles.title}>{facility_name_ko || facility_name}</h2>
      <p
        ref={descRef}
        className={`${styles.desc} ${expanded ? styles.full : styles.clamp}`}
        style={{ marginBottom: 0, fontSize: 15 }}
      >
        {description_ko || description}
      </p>
      {needClamp && (
        <button
          type="button"
          className={`${styles.moreBtn}${expanded ? ` ${styles.expanded}` : ''}`}
          onClick={() => setExpanded(e => !e)}
        >
          {expanded ? '숨기기' : '더보기'}
          <div className={styles['arrow-wrapper']}>
            <ArrowUnder className={styles.arrow} />
          </div>
        </button>
      )}
    </div>
  );
}

export default function NavFacilityContent({ data }) {
  const facilityData = data;

  return (
    <div className={styles['facility-grid']}>
      {facilityData && facilityData.length > 0 ? (
        facilityData.map((item, i) => <FacilityCard key={i} {...item} />)
      ) : (
        <p>해당 시설 정보가 없습니다.</p>
      )}
    </div>
  );
}
